// 恋爱占有欲指数测评题目数据
// 分为4个维度：控制欲望、嫉妒强度、情感依赖、关系不安

export const questionnaireData = {
  self: {
    // 给自己测的题目
    dimensions: [
      {
        id: 'cd_self',
        name: '控制欲望量表（自测版）',
        description: '评估在恋爱关系中对伴侣的控制欲望程度',
        questions: [
          { id: 'cd_self_1', text: '我经常想知道伴侣在做什么', required: true, type: 'likert' },
          { id: 'cd_self_2', text: '我希望伴侣把大部分空闲时间都花在我身上', required: true, type: 'likert' },
          { id: 'cd_self_3', text: '我不喜欢伴侣和其他异性单独相处', required: true, type: 'likert' },
          { id: 'cd_self_4', text: '我会查看伴侣的手机或社交媒体', required: true, type: 'frequency' },
          { id: 'cd_self_5', text: '我希望了解伴侣所有的行程安排', required: true, type: 'likert' },
          { id: 'cd_self_6', text: '我觉得伴侣应该随时回复我的消息', required: true, type: 'likert' },
          { id: 'cd_self_7', text: '我会限制伴侣与某些人的交往', required: true, type: 'frequency' },
          { id: 'cd_self_8', text: '我希望伴侣的穿着打扮符合我的期待', required: true, type: 'likert' },
          { id: 'cd_self_9', text: '我会要求伴侣向我报告日常活动', required: true, type: 'frequency' },
          { id: 'cd_self_10', text: '我不喜欢伴侣有太多独立的社交圈', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ji_self',
        name: '嫉妒强度量表（自测版）',
        description: '评估在恋爱关系中的嫉妒情绪强度',
        questions: [
          { id: 'ji_self_1', text: '当伴侣和异性说话时，我会感到嫉妒', required: true, type: 'likert' },
          { id: 'ji_self_2', text: '我担心伴侣会被别人吸引', required: true, type: 'likert' },
          { id: 'ji_self_3', text: '我会想象伴侣对我不忠的场景', required: true, type: 'frequency' },
          { id: 'ji_self_4', text: '看到伴侣和别人亲密互动会让我难受', required: true, type: 'likert' },
          { id: 'ji_self_5', text: '当伴侣称赞其他人时，我会感到不快', required: true, type: 'likert' },
          { id: 'ji_self_6', text: '我会比较自己和伴侣身边的其他人', required: true, type: 'frequency' },
          { id: 'ji_self_7', text: '伴侣的前任让我感到威胁', required: true, type: 'likert' },
          { id: 'ji_self_8', text: '我会因为嫉妒而质问伴侣', required: true, type: 'frequency' },
          { id: 'ji_self_9', text: '我担心伴侣会离开我去找更好的人', required: true, type: 'likert' },
          { id: 'ji_self_10', text: '看到伴侣和异性的合照会让我不舒服', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ed_self',
        name: '情感依赖量表（自测版）',
        description: '评估对伴侣的情感依赖程度',
        questions: [
          { id: 'ed_self_1', text: '没有伴侣我会感到空虚', required: true, type: 'likert' },
          { id: 'ed_self_2', text: '我需要伴侣的持续关注才能感到安心', required: true, type: 'likert' },
          { id: 'ed_self_3', text: '伴侣是我生活的全部重心', required: true, type: 'likert' },
          { id: 'ed_self_4', text: '我很难独自做决定', required: true, type: 'likert' },
          { id: 'ed_self_5', text: '我需要频繁确认伴侣对我的爱', required: true, type: 'frequency' },
          { id: 'ed_self_6', text: '离开伴侣一段时间会让我焦虑', required: true, type: 'likert' },
          { id: 'ed_self_7', text: '我的情绪很大程度上取决于伴侣的态度', required: true, type: 'likert' },
          { id: 'ed_self_8', text: '我会为了维持关系而牺牲自己的需求', required: true, type: 'frequency' },
          { id: 'ed_self_9', text: '我觉得自己离不开伴侣', required: true, type: 'likert' },
          { id: 'ed_self_10', text: '伴侣的一句话就能影响我一整天的心情', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ri_self',
        name: '关系不安量表（自测版）',
        description: '评估对恋爱关系稳定性的不安全感',
        questions: [
          { id: 'ri_self_1', text: '我经常担心这段关系会结束', required: true, type: 'frequency' },
          { id: 'ri_self_2', text: '我害怕被抛弃', required: true, type: 'likert' },
          { id: 'ri_self_3', text: '我总觉得自己不够好，配不上伴侣', required: true, type: 'likert' },
          { id: 'ri_self_4', text: '我会过度解读伴侣的言行', required: true, type: 'frequency' },
          { id: 'ri_self_5', text: '伴侣的冷淡会让我感到恐慌', required: true, type: 'likert' },
          { id: 'ri_self_6', text: '我需要反复确认伴侣不会离开我', required: true, type: 'frequency' },
          { id: 'ri_self_7', text: '我担心自己做错事会导致分手', required: true, type: 'likert' },
          { id: 'ri_self_8', text: '我会因为小事而怀疑伴侣的感情', required: true, type: 'frequency' },
          { id: 'ri_self_9', text: '我害怕伴侣发现"真实的我"后会失望', required: true, type: 'likert' },
          { id: 'ri_self_10', text: '我觉得这段关系随时可能破裂', required: true, type: 'likert' }
        ]
      }
    ]
  },
  partner: {
    // 为恋人测的题目（题目内容会稍有不同，从第三人称角度）
    dimensions: [
      {
        id: 'cd_partner',
        name: '控制欲望量表（恋人版）',
        description: '评估TA在恋爱关系中对您的控制欲望程度',
        questions: [
          { id: 'cd_partner_1', text: 'TA经常想知道我在做什么', required: true, type: 'likert' },
          { id: 'cd_partner_2', text: 'TA希望我把大部分空闲时间都花在TA身上', required: true, type: 'likert' },
          { id: 'cd_partner_3', text: 'TA不喜欢我和其他异性单独相处', required: true, type: 'likert' },
          { id: 'cd_partner_4', text: 'TA会查看我的手机或社交媒体', required: true, type: 'frequency' },
          { id: 'cd_partner_5', text: 'TA希望了解我所有的行程安排', required: true, type: 'likert' },
          { id: 'cd_partner_6', text: 'TA觉得我应该随时回复TA的消息', required: true, type: 'likert' },
          { id: 'cd_partner_7', text: 'TA会限制我与某些人的交往', required: true, type: 'frequency' },
          { id: 'cd_partner_8', text: 'TA希望我的穿着打扮符合TA的期待', required: true, type: 'likert' },
          { id: 'cd_partner_9', text: 'TA会要求我向TA报告日常活动', required: true, type: 'frequency' },
          { id: 'cd_partner_10', text: 'TA不喜欢我有太多独立的社交圈', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ji_partner',
        name: '嫉妒强度量表（恋人版）',
        description: '评估TA在恋爱关系中的嫉妒情绪强度',
        questions: [
          { id: 'ji_partner_1', text: '当我和异性说话时，TA会感到嫉妒', required: true, type: 'likert' },
          { id: 'ji_partner_2', text: 'TA担心我会被别人吸引', required: true, type: 'likert' },
          { id: 'ji_partner_3', text: 'TA会想象我对TA不忠的场景', required: true, type: 'frequency' },
          { id: 'ji_partner_4', text: '看到我和别人亲密互动会让TA难受', required: true, type: 'likert' },
          { id: 'ji_partner_5', text: '当我称赞其他人时，TA会感到不快', required: true, type: 'likert' },
          { id: 'ji_partner_6', text: 'TA会比较自己和我身边的其他人', required: true, type: 'frequency' },
          { id: 'ji_partner_7', text: '我的前任让TA感到威胁', required: true, type: 'likert' },
          { id: 'ji_partner_8', text: 'TA会因为嫉妒而质问我', required: true, type: 'frequency' },
          { id: 'ji_partner_9', text: 'TA担心我会离开TA去找更好的人', required: true, type: 'likert' },
          { id: 'ji_partner_10', text: '看到我和异性的合照会让TA不舒服', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ed_partner',
        name: '情感依赖量表（恋人版）',
        description: '评估TA对您的情感依赖程度',
        questions: [
          { id: 'ed_partner_1', text: '没有我TA会感到空虚', required: true, type: 'likert' },
          { id: 'ed_partner_2', text: 'TA需要我的持续关注才能感到安心', required: true, type: 'likert' },
          { id: 'ed_partner_3', text: '我是TA生活的全部重心', required: true, type: 'likert' },
          { id: 'ed_partner_4', text: 'TA很难独自做决定', required: true, type: 'likert' },
          { id: 'ed_partner_5', text: 'TA需要频繁确认我对TA的爱', required: true, type: 'frequency' },
          { id: 'ed_partner_6', text: '离开我一段时间会让TA焦虑', required: true, type: 'likert' },
          { id: 'ed_partner_7', text: 'TA的情绪很大程度上取决于我的态度', required: true, type: 'likert' },
          { id: 'ed_partner_8', text: 'TA会为了维持关系而牺牲自己的需求', required: true, type: 'frequency' },
          { id: 'ed_partner_9', text: 'TA觉得自己离不开我', required: true, type: 'likert' },
          { id: 'ed_partner_10', text: '我的一句话就能影响TA一整天的心情', required: true, type: 'likert' }
        ]
      },
      {
        id: 'ri_partner',
        name: '关系不安量表（恋人版）',
        description: '评估TA对恋爱关系稳定性的不安全感',
        questions: [
          { id: 'ri_partner_1', text: 'TA经常担心这段关系会结束', required: true, type: 'frequency' },
          { id: 'ri_partner_2', text: 'TA害怕被我抛弃', required: true, type: 'likert' },
          { id: 'ri_partner_3', text: 'TA总觉得自己不够好，配不上我', required: true, type: 'likert' },
          { id: 'ri_partner_4', text: 'TA会过度解读我的言行', required: true, type: 'frequency' },
          { id: 'ri_partner_5', text: '我的冷淡会让TA感到恐慌', required: true, type: 'likert' },
          { id: 'ri_partner_6', text: 'TA需要反复确认我不会离开TA', required: true, type: 'frequency' },
          { id: 'ri_partner_7', text: 'TA担心自己做错事会导致分手', required: true, type: 'likert' },
          { id: 'ri_partner_8', text: 'TA会因为小事而怀疑我的感情', required: true, type: 'frequency' },
          { id: 'ri_partner_9', text: 'TA害怕我发现"真实的TA"后会失望', required: true, type: 'likert' },
          { id: 'ri_partner_10', text: 'TA觉得这段关系随时可能破裂', required: true, type: 'likert' }
        ]
      }
    ]
  }
}

// 选项配置
export const optionsConfig = {
  likert: [
    { value: 1, label: '非常不同意' },
    { value: 2, label: '不同意' },
    { value: 3, label: '中性' },
    { value: 4, label: '同意' },
    { value: 5, label: '非常同意' }
  ],
  frequency: [
    { value: 1, label: '从不' },
    { value: 2, label: '很少' },
    { value: 3, label: '有时' },
    { value: 4, label: '经常' },
    { value: 5, label: '总是' }
  ]
}

// 获取所有题目（扁平化）
export function getAllQuestions(type = 'self') {
  const data = questionnaireData[type]
  const allQuestions = []
  let questionNumber = 1
  
  data.dimensions.forEach(dimension => {
    dimension.questions.forEach(question => {
      allQuestions.push({
        ...question,
        number: questionNumber++,
        dimensionId: dimension.id,
        dimensionName: dimension.name
      })
    })
  })
  
  return allQuestions
}

// 获取题目总数
export function getTotalQuestions() {
  return 40
}

